import { Checkbox } from './Checkbox';
import { CheckboxGroup } from './Group';
import { CheckboxContent } from './Content';
import { CheckboxFont } from './Font';
Checkbox.Content = CheckboxContent;
Checkbox.Group = CheckboxGroup;
Checkbox.Font = CheckboxFont;
export default Checkbox;
